import {
  AfterViewInit, ChangeDetectorRef,
  Component, DoCheck,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {faFileExcel, faFilePdf} from '@fortawesome/free-solid-svg-icons';
import {ParametrosTablaInterface} from '../../interfaces/parametros-tabla.interface';
import {ExportarExcel} from '../../util/exportar-excel';
import {NgxSpinnerService} from 'ngx-spinner';
import {EventosTablaInterface} from '../../interfaces/eventos-tabla.interface';
import {MatSort, Sort} from '@angular/material/sort';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {Constants} from '../../constants/constants';
import swal from 'sweetalert2';
import {TablaValidacionesService} from '../../services/tabla-validaciones.service';
import {PageEvent} from '@angular/material/paginator';
import {MatInput} from '@angular/material/input';
import {Controles} from '../../constants/controles';


@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.scss']
})
export class TablaComponent implements OnInit, AfterViewInit, DoCheck {

  @ViewChild('idpaginator') tablaPaginador: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('idExportar') table: ElementRef;
  @Input() parametrosTabla: ParametrosTablaInterface;

  @ViewChild(MatInput) matInput: MatInput;
  ingresosSuma: any;


  @Output() emitter: EventEmitter<EventosTablaInterface> = new EventEmitter<EventosTablaInterface>();
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[];
  dataNames: string[];
  formatColumn: string[];
  iconoExcel: any = faFileExcel;
  iconoPdf: any = faFilePdf;
  pageSize: number;
  pageSizeOptions: number[];
  pageIndex: number = 0;
  intervalo: any;
  actualizarTabla = false;
  eventoTabla: EventosTablaInterface;
  iconos: string[] = ['ft-edit', 'ft-home', 'ft-phone', 'ft-folder', 'ft-eye', 'ft-trash', 'ft-user', 'ft-file-minus',
    'ft-file-text', 'ft-send', 'icon-envelope-open', 'ft-credit-card', 'ft-user-check', 'ft-book-open', 'ft-layers', 'ft-book', 'ft-users',
    'ft-dollar-sign', 'ft-upload', 'ft-circle', 'ft-check-circle', 'ft-x-square', 'ft-clock', 'ft-slack', 'ft-clipboard', 'ft-info', 'ft-x-square', 'ft-bar-chart-2', 'ft-refresh-cw'];
  color: string[] = ['success', 'info', 'warning', 'danger', 'dark'];
  Control = Controles;
  isLoading = true;
  rightPanelStyle: any = {};
  optionSelectedMenuContext: any;
  pageEvent: PageEvent;
  filterSearch: string;


  constructor(private excel: ExportarExcel,
              private cd: ChangeDetectorRef,
              private spinner: NgxSpinnerService,
              private liveAnnouncer: LiveAnnouncer,
              public constants: Constants,
              private tablaValidaciones: TablaValidacionesService
  ) {
  }

  ngOnInit(): void {
    this.closeContextMenu();
    this.displayedColumns = this.parametrosTabla.displayedColumns;
    this.dataNames = this.parametrosTabla.dataNames;
    this.formatColumn = this.parametrosTabla.formatColumn;
    this.pageSizeOptions = this.parametrosTabla.pageSizeOptions;

    this.setPreferencePaginator();

  }

  ngAfterViewInit(): void {
    return;
  }

  ngDoCheck(): void {

    if ((this.parametrosTabla.evento !== undefined
      && this.parametrosTabla.evento.accion === this.constants.ACTUALIZAR_TABLA)) {

      this.parametrosTabla.evento = {
        accion: ''
      };

      this.intervalo = setTimeout(() => {
        this.dataSource = new MatTableDataSource(this.parametrosTabla.dataSource);
        this.setPreferencePaginator();
        this.dataSource.paginator = this.tablaPaginador;
        this.dataSource.sort = this.sort;
        this.dataSource.filter = this.filterSearch;
        this.isLoading = false;

        this.cd.markForCheck();
      }, 800);
    }
  }


  handlePage(e: any) {
    /*sessionStorage.setItem(this.parametrosTabla.tabla.toString(), this.utileriasService.encrypt(JSON.stringify(e)));
    this.updatePreferenceDataBase(e);*/
    return e;
  }

  setPreferencePaginator() {
    /*if (this.parametrosTabla.tabla !== undefined && sessionStorage.getItem(this.parametrosTabla.tabla.toString()) != null) {
      const preferenceStorage = JSON.parse(this.utileriasService.decrypt(sessionStorage.getItem(this.parametrosTabla.tabla.toString())));
      if (preferenceStorage !== null) {
        this.pageSize = preferenceStorage.pageSize;
        this.pageIndex = preferenceStorage.pageIndex;

      } else {
        this.pageSize = this.parametrosTabla.pageSize;
        this.pageIndex = 0;
      }
    } else {
      this.pageSize = this.parametrosTabla.pageSize;
      this.pageIndex = 0;
    }*/
  }

  updatePreferenceDataBase(preferenceStorage): void {
    /*this.preferenceUser = {
      idusuari: this.authentication.idUsuario,
      tabla: this.parametrosTabla.tabla,
      preferencias: JSON.stringify(preferenceStorage)
    }

    this._usprefer.postUsprefer(this.preferenceUser).subscribe((_) => {
      this.cd.markForCheck();
    });*/
  }

  exportTable(): void {
    this.excel.exportarExcel(this.table);
  }

  exportTableColumnas() {
    //this.excel.exportarExcelColumnas(this.parametrosTabla.dataSourceGeneral, this.parametrosTabla.displayedColumnsExport);
  }

  filterTable(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.filterSearch = this.dataSource.filter;
    this.parametrosTabla.dataSource = this.dataSource.filteredData;
    this.filterSearch = this.dataSource.filter;
  }

  emit(evento: string, element?: any): void {
    switch (evento.trim()) {
      case this.constants.ACTUALIZAR_TABLA:
        this.eventoTabla = {
          accion: evento.trim()
        }
        this.actualizarTabla = true;
        break;
      case this.constants.DOCUMENTOS:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element,
          tablaAdjuntos: this.parametrosTabla.tablaAdjuntos,
          rutaSFTP: this.parametrosTabla.rutaSFTP,
          tabla: this.parametrosTabla.tabla,
          comentarios: this.parametrosTabla.comentarios
        }
        break;
      case this.constants.ELIMINAR_DOCUMENTACION:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        this.emitter.emit(this.eventoTabla);
        break;
      case this.constants.ELIMINAR:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        this.deleteConfirm(this.eventoTabla);
        break;
      default:
        this.eventoTabla = {
          accion: evento.trim(),
          objeto: element
        }
        break;
    }

    if (evento !== this.constants.ELIMINAR) {
      this.emitter.emit(this.eventoTabla);
    }

  }


  setIconColumn(columna): string {
    const estilo = ' font-medium-3 mr-2 ';

    switch (columna.trim()) {
      case this.constants.EDITAR:
        return this.iconos[0] + estilo + this.color[1];
        break;
      case this.constants.DOMICILIOS:
        return this.iconos[1] + estilo + this.color[2];
        break;
      case this.constants.CONTACTOS:
        return this.iconos[2] + estilo + this.color[0];
        break;
      case this.constants.DOCUMENTOS:
        return this.iconos[3] + estilo + this.color[4];
        break;
      case this.constants.VISUALIZAR:
        return this.iconos[4] + estilo + this.color[1];
        break;
      case this.constants.ELIMINAR:
      case this.constants.ELIMINAR_DOCUMENTACION:
        return this.iconos[5] + estilo + this.color[3];
        break;
      case this.constants.CLIENTES:
        return this.iconos[6] + estilo + this.color[2];
        break;
      case this.constants.XML:
        return this.iconos[7] + estilo + this.color[2];
        break;
      case this.constants.PDF:
      case this.constants.CARTA:
        return this.iconos[8] + estilo + this.color[0];
        break;
      case this.constants.EMAIL:
        return this.iconos[9] + estilo + this.color[4];
        break;
      case this.constants.NOTIFICADO:
        return this.iconos[10] + estilo + this.color[2];
        break;
      case this.constants.CUENTAS_BANCARIAS:
        return this.iconos[11] + estilo + this.color[3];
        break;
      case this.constants.INMUEBLES:
        return this.iconos[1] + estilo + this.color[0];
        break;
      case this.constants.PROPIETARIOS:
        return this.iconos[12] + estilo + this.color[2];
        break;
      case this.constants.CONDICIONES:
        return this.iconos[13] + estilo + this.color[2];
        break;
      case this.constants.CONTRATOS:
        return this.iconos[14] + estilo + this.color[2];
        break;
      case this.constants.CONVENIOS:
        return this.iconos[15] + estilo + this.color[2];
        break;
      case this.constants.ARRENDADORES:
        return this.iconos[16] + estilo + this.color[2];
        break;
      case this.constants.FACTURACION_CONDICIONES:
        return this.iconos[17] + estilo + this.color[2];
        break;
      case this.constants.PAGADO:
        return this.iconos[17] + estilo + this.color[0];
        break;
      case this.constants.UPLOAD:
        return this.iconos[18] + estilo + this.color[0];
        break;
      case this.constants.VALIDAR:
        return this.iconos[19] + estilo + this.color[1];
        break;
      case this.constants.REVISADO:
      case this.constants.MOVIMIENTO_AFIN:
        return this.iconos[20] + estilo + this.color[0];
        break;
      case this.constants.CANCELAR:
        return this.iconos[21] + estilo + this.color[3];
        break;
      case this.constants.RELOJ:
        return this.iconos[22] + estilo + this.color[3];
        break;
      case this.constants.CUENTAS_CONTABILIDAD:
        return this.iconos[23] + estilo + this.color[4];
        break;
      case this.constants.REQUISICION:
        return this.iconos[24] + estilo + this.color[4];
        break;
      case this.constants.VALIDAR_CFDI:
        return this.iconos[25] + estilo + this.color[4];
        break;
      case this.constants.CANCELAR_CFDI:
        return this.iconos[26] + estilo + this.color[2];
        break;
      case this.constants.TERCEROS:
        return this.iconos[16] + estilo + this.color[2];
        break;
      case this.constants.SOLICITUD:
        return this.iconos[8] + estilo + this.color[0];
        break;
      case this.constants.MOVIMIENTOS:
        return this.iconos[27] + estilo + this.color[1];
        break;
      case this.constants.RENOVACION:
        return this.iconos[28] + estilo + this.color[1];
        break;
      default:
        return '';
        break;
    }

  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this.liveAnnouncer.announce('Sorting cleared');
    }
  }

  setBackground(dataSource: any, column: any): string {
    return this.tablaValidaciones.setStyleColumn(this.parametrosTabla.tabla, dataSource, column);
  }

  displayColumn(dataSource: any, column: any): boolean {
    return this.tablaValidaciones.setDisplayColumn(this.parametrosTabla.tabla, dataSource, column, this.parametrosTabla.documentacion);
  }

  isGranted(column: any) {
    return this.tablaValidaciones.isGranted(this.parametrosTabla.tabla, column, this.parametrosTabla.documentacion);
  }

  deleteConfirm(evento: any): any {
    swal.fire({
      title: '¿Desea eliminar el registro seleccionado?',
      text: '¡No podrás revertir esto!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
          this.eventoTabla = {
            accion: evento.accion,
            objeto: evento.objeto
          }
          this.emitter.emit(this.eventoTabla);
        }
      }
    );
  }

  displayCurrency(dataSource: any, column: any): boolean {
    return this.tablaValidaciones.displayCurrency(this.parametrosTabla.tabla, dataSource, column);
  }

  detectRightMouseClick(event: any, element: any): void {
    if (event.button == 2) {
      this.optionSelectedMenuContext = element;
      this.rightPanelStyle = {
        'display': 'block',
        'position': 'absolute',
        'left.px': event.layerX,
        'top.px': event.layerY
      }
    }
  }

  closeContextMenu() {
    this.rightPanelStyle = {
      'display': 'none',
    }
  }

  displayOptionMenuContext(columna: any) {
    return this.displayColumn(this.optionSelectedMenuContext, columna);
  }


  sumTotal(column: string) {

    // obtener la columna sin sufijos o transformaciones (como en el original)
    const colKey = column.split('_')[0];

    // Filtrado y paginación aplicada: dataSource.filteredData es lo filtrado
    // Si quieres solo la página visible, usar dataSource._renderData.value (pero _renderData es privado)
    const data = this.parametrosTabla.dataSource;

    return data.reduce((acc, item) => acc + (Number(item[colKey]) || 0), 0);
  }


}
